import { Form } from "formik";
import React from "react";

import Button from "@/components/UI/Button";
import FormikInput from "@/components/UI/FormikInput";

// Extracted from src/containers/Dashboard/Providers/ReferralView.js — that file keeps its
// own copy for its own usage; this copy is for PatientsList's archive popup only.
export const renderStatusForm = (formikProps, hidePopUp, patientName) => {
  return (
    <Form className="py-4">
      <div className="mx-auto">
        <div className="container px-0">
          <label className="Label pb-2" data-private>
            Archive: {patientName}
          </label>
          <div className="row">
            {[
              {
                elementConfig: {
                  label: "Reason",
                  options: [
                    {
                      display: "Patient decline to proceed",
                      value: "Patient decline to proceed",
                    },
                    {
                      display: "Patient unresponsive",
                      value: "Patient unresponsive",
                    },
                    {
                      display: "Patient is not a fit for aptihealth",
                      value: "Patient is not a fit for aptihealth",
                    },
                  ],
                },
                elementType: "select",
                name: "referral_status_reason",
              },
              {
                elementConfig: {
                  label: "Reason Context",
                  type: "textArea",
                },
                elementType: "textarea",
                name: "referral_status_reason_context",
              },
            ].map((formEl) => {
              return (
                <div className="col-12" key={formEl.name}>
                  <FormikInput
                    errors={formikProps.errors}
                    formEl={formEl}
                    touched={formikProps.touched}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="d-lg-flex d-block text-center justify-content-lg-end tw:justify-center">
        <Button
          className="Btn Btn--otl-pri Btn-sm mr-lg-3 mb-3 mb-lg-0"
          onClick={hidePopUp}
          type="button"
        >
          Cancel
        </Button>
        <Button className="Btn Btn--pri Btn-sm" type="submit">
          Save
        </Button>
      </div>
    </Form>
  );
};
